import { Link } from 'react-router-dom';
import CategoryBadge from './CategoryBadge';

function ArticleCard({ artigo, featured = false }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  if (featured) {
    return (
      <Link
        to={`/blog/${artigo.slug}`}
        className="group block col-span-full bg-card rounded-2xl border border-border overflow-hidden shadow-card hover:-translate-y-1 transition-all duration-300 no-underline"
        style={{ '--tw-shadow-colored': '0 20px 60px -12px hsl(24 95% 53% / 0.15)' }}
        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 12px 40px -8px hsl(24 95% 53% / 0.18)'}
        onMouseLeave={(e) => e.currentTarget.style.boxShadow = ''}
      >
        <div className="grid md:grid-cols-2 gap-0">
          <div className="h-48 md:h-full bg-muted">
            {artigo.imagem_capa ? (
              <img src={artigo.imagem_capa} alt={artigo.titulo} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-accent/10">
                <svg className="w-16 h-16 text-muted-foreground/30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
              </div>
            )}
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            {artigo.blog_categorias && (
              <CategoryBadge categoria={artigo.blog_categorias} className="mb-3" />
            )}
            <h2 className="text-xl md:text-2xl font-bold text-secondary mb-3 group-hover:text-primary transition-colors">
              {artigo.titulo}
            </h2>
            <p className="text-muted-foreground text-sm mb-4 line-clamp-3">{artigo.resumo}</p>
            <div className="flex items-center gap-4 text-xs text-muted-foreground/70">
              <span>{formatDate(artigo.published_at)}</span>
              <span>{artigo.tempo_leitura || 5} min de leitura</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/blog/${artigo.slug}`}
      className="group block bg-card rounded-2xl border border-border overflow-hidden shadow-card hover:-translate-y-1 transition-all duration-300 no-underline"
      onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 12px 40px -8px hsl(24 95% 53% / 0.18)'}
      onMouseLeave={(e) => e.currentTarget.style.boxShadow = ''}
    >
      <div className="h-44 bg-muted">
        {artigo.imagem_capa ? (
          <img src={artigo.imagem_capa} alt={artigo.titulo} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-accent/10">
            <svg className="w-12 h-12 text-muted-foreground/30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
          </div>
        )}
      </div>
      <div className="p-5">
        {artigo.blog_categorias && (
          <CategoryBadge categoria={artigo.blog_categorias} className="mb-2" />
        )}
        <h3 className="text-base font-bold text-secondary mb-2 group-hover:text-primary transition-colors line-clamp-2">
          {artigo.titulo}
        </h3>
        <p className="text-muted-foreground text-sm mb-3 line-clamp-2">{artigo.resumo}</p>
        <div className="flex items-center gap-3 text-xs text-muted-foreground/70">
          <span>{formatDate(artigo.published_at)}</span>
          <span className="w-1 h-1 bg-muted-foreground/30 rounded-full" />
          <span>{artigo.tempo_leitura || 5} min</span>
        </div>
      </div>
    </Link>
  );
}

export default ArticleCard;
